import { type LicenseMessageDisposition } from "@octopusdeploy/octopus-server-client";
import pluralize from "pluralize";
import React from "react";
import { UsageCard } from "./UsageOverviewCard";
type LicenseUsageCardProps = {
    licenseDurationDays: number;
    daysToEffectiveExpiryDate: number;
    disposition: LicenseMessageDisposition;
};
export function LicenseUsageCard({ licenseDurationDays, daysToEffectiveExpiryDate, disposition }: LicenseUsageCardProps) {
    // trial expires today (if remainingDays is 0)
    const daysSinceLicenseStart = Math.max(0, licenseDurationDays - daysToEffectiveExpiryDate + 1); // handles when a customer is given a more than 30 day trial
    const circularProgressPercentage = (daysSinceLicenseStart / licenseDurationDays) * 100;
    return <UsageCard title={"Trial ends in"} subtitle={`${pluralize("day", daysToEffectiveExpiryDate + 1, true)}`} percentage={circularProgressPercentage} disposition={disposition}/>;
}
